// AboutUsSection.js
import React from 'react';
import './AboutUsSection.css';
import Ourteam1 from '../image/Ourteam1.jpg';
import Ourteam2 from '../image/Ourteam2.jpg';
import Ourteam3 from '../image/Ourteam3.jpg';
import Ourteam4 from '../image/Ourteam4.jpg';
import Ourteam5 from '../image/Ourteam5.jpg';
import Ourteam6 from '../image/Ourteam6.jpg';
import Ourteam7 from '../image/Ourteam7.jpg';
import Ourteam8 from '../image/Ourteam8.jpg';
import whychooseus from '../image/chooseus.gif'; // Assuming you have an image for "Why Choose Us"

const AboutUsSection = () => {
  return (
    <>
      {/* About Us Section */}
      <section className="about-us-section">
        <div className="about-us-container">
          <div className="about-us-images">
            <div className="image-column">
              <div className="image-box1"><img src={Ourteam1} alt="Team Discussion" /></div>
              <div className="image-box2"><img src={Ourteam2} alt="Meeting Notes" /></div>
            </div>
            <div className="image-column">
              <div className="image-box3"><img src={Ourteam3} alt="Programming Team" /></div>
              <div className="image-box4"><img src={Ourteam4} alt="Collaboration" /></div>
            </div>
          </div>
          <div className="about-us-text">
            <h2>About us</h2>
            <p>
              <strong>Talent Trek Technologies</strong> is a leading provider of Training & Development and software services.
              Starting as an AI product company, we shifted to IT services in 2024 to support non-IT and software companies with customized solutions.
              We offer end-to-end IT services for healthcare, retail, and finance, ensuring secure, compliant, and high-performing systems.
              As a digital transformation partner, we help businesses overcome complex challenges with smart, scalable technology solutions.
              We prioritize collaboration, innovation, and long-term partnerships empowering organizations to thrive in a dynamic digital landscape.
              With a future-ready mindset, we continue to evolve, innovate, and lead the way in shaping tomorrow’s tech-driven success stories.
            </p>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section">
        <div className="why-choose-card">
          <div className="why-choose-left">
            <h2 className="why-choose-title">Why Choose Us ?</h2>
            <p className="why-choose-desc">
              Here’s why choosing us sets you apart: We’re more than just a training institute we’re your career partner.
              Our experienced and certified trainers ensure high-quality instruction, while our hands-on, real-world learning approach
              prepares you for actual industry challenges. With flexible learning options available both online and offline,
              you can learn at your convenience. We also offer dedicated placement assistance and career counseling to guide
              you every step of the way. Our industry-relevant courses and certifications are designed to give you a competitive edge
              in today’s job market.
            </p>
          </div>

          <div className="why-choose-image">
            <img src={whychooseus} alt="Why Choose Us" />
          </div>
        </div>

        <div className="why-choose-content">
          <div className="why-choose-card">
            <div className="why-choose-left">
              <div className="why-choose-bar"></div>
              <p>
                Talent Trek Technologies is a provider of Training & Development and IT services,
                offering customized solutions for healthcare, retail, and financial sectors.
                Evolving from an AI product company, we now help businesses navigate digital transformation
                with secure, scalable, and high-performance technology solutions.
              </p>
              <br></br>
              <button className="choose-contact-btn">Contact us</button>
            </div>
            <div className="why-choose-right">
              <div className="choose-feature"><span className="icon">🔘</span> <strong>IT Consulting</strong></div>
              <div className="choose-feature"><span className="icon">🛡️</span> <strong>Cyber Security</strong></div>
              <div className="choose-feature"><span className="icon">📦</span> <strong>Software Dev</strong></div>
              <div className="choose-feature"><span className="icon">🌐</span> <strong>Digital Transform</strong></div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Team Section */}
      <section className="our-team-section">
        <h2 className="our-team-title">Meet Our Team</h2>
        <p className="our-team-desc">
          At Talent Trek Technologies, our strength lies in our people. Our diverse and experienced team of technologists,
          strategists, trainers, and innovators work together to bring cutting-edge solutions to life. We believe in
          collaboration, continuous learning, and customer focused delivery, ensuring every project achieves excellence.
        </p>
        <div className="team-carousel">
          <div className="carousel-track">
            {[Ourteam1, Ourteam2, Ourteam3, Ourteam4, Ourteam5, Ourteam6, Ourteam7, Ourteam8,
              Ourteam1, Ourteam2, Ourteam3, Ourteam4, Ourteam5, Ourteam6, Ourteam7, Ourteam8].map((img, i) => (
              <div className="carousel-slide" key={i}>
                <img src={img} alt={`Team Member ${i + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Subscribe Section */}
      <section className="subscribe-section">
        <div className="subscribe-content">
          <h2 className="subscribe-title">Talent Trek Technologies</h2>
          <form className="subscribe-form">
            <input type="email" placeholder="Enter your email" className="subscribe-input" />
            <button type="submit" className="subscribe-btn">LOGIN</button>
          </form>
        </div>
      </section>
    </>
  );
};

export default AboutUsSection;